// The Radar in the new interface (9 October 2026): the single screen, its
// Topics | Audiences switch, and the panel of an overlap opened on click. Its
// other texts come from the `radar` namespace, shared with the classic screen.
export default {
  sousTitre: {
    sujets: '{s} rising topics across {p} audiences',
    publics: '{p} audiences observed',
  },
  vue: {
    aria: 'View',
    sujets: 'Topics',
    publics: 'Audiences',
    pays: 'Countries',
  },
  scene: {
    aria: 'The radar: topics and audiences, by family',
  },
  portee: {
    presqueTous: 'almost all',
    moitie: 'half',
    quelques: 'a few',
    tresConcernes: 'most involved',
    concernes: 'involved',
    peuConcernes: 'least involved',
  },
  lecture: {
    sujets: 'At the centre, what all your audiences talk about. The bigger the dot, the newer the topic; each ring around it, one more day.',
    publics: 'At the centre, the audiences carrying the most rising topics. The bigger the dot, the more topics of the day.',
    recoupements: 'Click a line to compare two audiences.',
  },
  recoupement: {
    titre: 'Audience overlap',
    aria: '{a} and {b}: {pct}% in common',
    prochesSujets: 'of topics in common',
    prochesPersonas: 'of personas in common',
    sansSujets: 'These two audiences share no rising topic right now.',
    sansPersonas: 'Their personas do not overlap, or have not been read yet.',
    sujetsCommuns: 'Topics they share',
    personasCommuns: 'Personas they share',
    seul: 'Only on {nom}',
    rienSeul: 'Nothing of its own',
  },
  sujet: {
    jours: 'Days the topic came back',
  },
  et: 'and',
  fermer: 'Close',
}
